import { Injectable } from "@angular/core";
import { SmartTableData } from "../data/smart-table";

@Injectable()
export class SmartTableService extends SmartTableData {
  data = [
    {
      deviceId: 1,
      State: "ON",
      Name: "testname",
      isInstalled: "Yes",
      Hospital: "testhos",
      Date: "1-1-2021",
      Location: "testloc",
      Brand: "testbrand",
      salesPersonName: "testnamesp",
      salesPersonEmail: "testemailsp",
    },
    {
      id: 2,
      Matricule: "G003",
      Longitude: "8.1855555",
      Latitude: "51.78888",
      History: "On",
      Name: "machine",
      Logs: "Good",
    },
    {
      id: 3,
      Matricule: "G003",
      Longitude: "8.1855555",
      Latitude: "51.78888",
      History: "On",
      Name: "machine",
      Logs: "Good",
    },
  ];

  getData() {
    return this.data;
  }
}
